// extracted by mini-css-extract-plugin
export default {"text":"EuFooter_text__I3Skm","panel":"EuFooter_panel__Mgopy"};